import { HugeiconsIcon } from "@hugeicons/react";
import { InformationCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, CollapsibleTrigger } from "@workspace/frontend-ui";
import type { FC } from "react";
import useTranslations from "../../i18n/useTranslations";

const RewardInfoButton: FC = () => {
  const t = useTranslations();

  return (
    <CollapsibleTrigger asChild>
      <Button
        variant="unstyled"
        size="icon-xs"
        aria-label={t("reward_center.reward.info")}
        className="size-5 text-muted-foreground hover:text-foreground data-[state=open]:text-foreground [&_svg]:size-5"
      >
        <HugeiconsIcon icon={InformationCircleIcon} />
      </Button>
    </CollapsibleTrigger>
  );
};

export default RewardInfoButton;
